import { yup } from "@";
import type { LandingPageFormValues } from "../types";
import { SLUG_PATTERN } from "./slug";

const slugRule = yup
  .string()
  .required("الرابط (Slug) مطلوب")
  .min(3)
  .max(20)
  .matches(SLUG_PATTERN, "يجب أن يحتوي الرابط على أحرف وأرقام وشرطات فقط");

export const schema = yup.object({
  name: yup.string().required("اسم الصفحة مطلوب"),
  slug: slugRule,
  seoTitle: yup.string().nullable(),
  seoDescription: yup.string().nullable(),
  projectId: yup
    .number()
    .typeError("يجب اختيار مشروع")
    .required("يجب اختيار مشروع")
    .min(1, "يجب اختيار مشروع"),
  themeId: yup
    .number()
    .typeError("يجب اختيار ثيم")
    .required("يجب اختيار ثيم")
    .min(1, "يجب اختيار ثيم"),
});

export const defaultValues: Partial<LandingPageFormValues> = {
  name: "",
  slug: "",
  seoTitle: "",
  seoDescription: "",
  projectId: null,
  themeId: null,
};
